import assets from 'assets/icons/sprites.svg';

interface IconProps {
	name: string;
	color?: string;
	width?: number;
	height?: number;
	style?: any;
}

function Icon({ name, color, style, width = 20, height = 20 }: IconProps) {
	return (
		<svg style={{ fill: color ? color : undefined, width: width, height: height, ...style }}>
			<use href={assets + '#' + name}></use>
		</svg>
	);
}

export default Icon;
